// @ts-nocheck
import { populate } from 'populate';
import type { Container, Sprite, Text } from 'pixi.js';
import { RaceEventBigCarLayout } from './RaceEventBigCarLayout';

const raw = {
  list: [
    {
      id: 'f7df203c-d5ff-434b-8f2d-cbc976d981be',
      type: 'Container',
      name: 'root',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      parent: ''
    },
    {
      id: '7a2491a8-abd7-4030-9686-3bf7ca8396aa',
      type: 'Sprite',
      name: 'buttonBackground',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Daily_Reward_Icon_Button',
      parent: 'f7df203c-d5ff-434b-8f2d-cbc976d981be'
    },
    {
      id: '85230c49-6c66-438e-a6c8-4d9c4186c276',
      type: 'Layout',
      name: 'carLayout',
      className: '',
      path: 'raceEvent/RaceEventBigCarLayout.ts',
      percentX: 0,
      percentY: 0,
      handleResize: false,
      x: 0,
      y: -12,
      scale: {
        x: 0.4,
        y: 0.4
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      parent: 'f7df203c-d5ff-434b-8f2d-cbc976d981be'
    },
    {
      id: 'a824d85c-6e4e-46ce-aae7-186ab1ca4f56',
      type: 'Container',
      name: 'positionContainer',
      className: '',
      x: 45,
      y: -50,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'f7df203c-d5ff-434b-8f2d-cbc976d981be'
    },
    {
      id: '7f534382-7f7d-48cc-8ac3-14bf25c827f4',
      type: 'Container',
      name: 'joinButton',
      className: '',
      x: 0,
      y: 48,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'f7df203c-d5ff-434b-8f2d-cbc976d981be'
    },
    {
      id: 'c31156c2-de46-4a1b-99b9-94a85653e9dd',
      type: 'Container',
      name: 'timerContainer',
      className: '',
      x: 0,
      y: 48,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'f7df203c-d5ff-434b-8f2d-cbc976d981be'
    },
    {
      id: 'd62db8c9-fbd8-4406-ac94-60a96a8a3bff',
      type: 'Sprite',
      name: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Menu_Icon_Join_Button',
      parent: '7f534382-7f7d-48cc-8ac3-14bf25c827f4'
    },
    {
      id: 'cc15dc03-4b7a-4e77-9733-61792381c626',
      type: 'Text',
      name: '',
      className: 'upperCase_SPL',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Join',
      localize: true,
      maxWidth: 87,
      maxHeight: 54,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 24,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: '#145036',
        strokeThickness: 4,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: true,
        dropShadowAlpha: 1,
        dropShadowAngle: 1.57,
        dropShadowBlur: 0,
        dropShadowColor: '#145036',
        dropShadowDistance: 1,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '7f534382-7f7d-48cc-8ac3-14bf25c827f4'
    },
    {
      id: 'd114754b-d7fd-45ee-9a27-db25843328c1',
      type: 'Sprite',
      name: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Icon_Timer_Background',
      parent: 'c31156c2-de46-4a1b-99b9-94a85653e9dd'
    },
    {
      id: '8f214948-3033-4572-aa8b-54c8625a853d',
      type: 'Text',
      name: 'timerText',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '1h 20m',
      localize: false,
      maxWidth: 87,
      maxHeight: 44,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 24,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: '#6e2009',
        stroke: 'white',
        strokeThickness: 2,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: 'c31156c2-de46-4a1b-99b9-94a85653e9dd'
    }
  ],
  x: 0,
  y: 0,
  width: 760,
  height: 760,
  version: '2.0.0',
  handleResize: false
} as const;

export class RaceEventIconLayout {
  static raw = raw;
  root!: Container;
  buttonBackground!: Sprite;
  carLayout!: RaceEventBigCarLayout;
  positionContainer!: Container;
  joinButton!: Container;
  timerContainer!: Container;
  timerText!: Text;
  upperCase_SPL!: (Text)[];
  StateName!: never;

  constructor() {
    populate(this, raw);
  }
}
